import React from 'react'

import Divider from './Divider'
import SummaryAdditionalNotes from './SummaryAdditionalNotes'
import SummaryDataItem from './SummaryDataItem'

type Props = {
  phone?: string
  url?: string
  notes?: string
}

function ExtraDetails({ url, phone, notes }: Props) {
  if (!url && !phone && !notes) return null
  return (
    <>
      <Divider />
      <SummaryDataItem title="Website" value={url} url={url} />
      <SummaryDataItem
        title="Phone number"
        value={phone}
        url={`tel:${phone}`}
      />
      <SummaryAdditionalNotes notes={notes} />
    </>
  )
}

export default ExtraDetails
